// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1p-AS","rootCenter":"LoadMoreObserver_rootCenter__3pJqu","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__eSaJi"};